import { createSelector } from 'reselect'

const getMakesAndModels = (state: { [key: string]: any }) => state.entities.listings.filters?.makesAndModels || []

export default createSelector(getMakesAndModels, (listings) => listings)
